export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14502.598a5ab0.jpg";